var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertWarningIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.168,
    height: 14,
    viewBox: "0 0 15.168 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.97,5.08,3.514,16.863A1.108,1.108,0,0,0,4.5,18.5H17.419a1.111,1.111,0,0,0,.988-1.637L11.946,5.08A1.132,1.132,0,0,0,9.97,5.08ZM11.6,9.969l-.131,4.448H10.448l-.131-4.448Zm-.642,6.869a.671.671,0,1,1,.7-.671A.677.677,0,0,1,10.958,16.837Z",
    transform: "translate(-3.375 -4.5)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertWarningIcon);
export default __webpack_public_path__ + "static/media/alert-warning-icon.566ed8af97951c0872bdcb0272f4c68c.svg";
export { ForwardRef as ReactComponent };